export const FilterIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.50351 6.98933L4.50351 2.67432"
      stroke="#AAB3D0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.50286 9.69727C3.14166 9.69727 2.68833 10.1512 2.68833 11.5118C2.68833 12.8724 3.14166 13.3263 4.50286 13.3263C5.86405 13.3263 6.31738 12.8724 6.31738 11.5118C6.31738 10.1512 5.86405 9.69727 4.50286 9.69727Z"
      stroke="#AAB3D0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4957 9.01123L11.4957 13.3257"
      stroke="#AAB3D0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.497 6.30397C12.8576 6.30397 13.3115 5.85004 13.3115 4.48944C13.3115 3.12825 12.8576 2.67432 11.497 2.67432C10.1358 2.67432 9.68247 3.12825 9.68247 4.48944C9.68247 5.85004 10.1358 6.30397 11.497 6.30397Z"
      stroke="#AAB3D0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
